import { render, staticRenderFns } from "./404.vue?vue&type=template&id=606b8de4&"
import script from "./404.vue?vue&type=script&lang=ts&"
export * from "./404.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports